import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

import { TranslateService } from '@ngx-translate/core';

import { PaymentMethodsFacade, SessionService } from '@ridango/components';
import Env from '@ridango/core/env';
import { CartStatus } from '@ridango/components/lib/purchase/purchase.model';

@Injectable()
export class CartGuard implements CanActivate {
    constructor(
        private session: SessionService,
        private router: Router,
        private translate: TranslateService,
        private paymentMethod: PaymentMethodsFacade,
        @Inject('ENV') private env: Env
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (this.paymentMethod.getCartStatus() === CartStatus.LOCKED) {
            this.paymentMethod.setCartRedirectUrl(state.url);
            return;
        }
        return true;
    }
}
